import { fixedNumber } from '@/core/helpers/formatters';
import { fromIsoWeekday, getTimetableDateForWeekdayIndex } from '@/core/helpers/dateHelper';
import { Timetable } from '@/core/models/timetable.interface';
import dayjs from 'dayjs';
import { Employment } from '../employments/employment.interface';

function resolveTimetableDate(timetable: Timetable, from: string): string | null {
   if (timetable.date) {
      return timetable.date;
   }

   if (timetable.weekday != null) {
      return getTimetableDateForWeekdayIndex(from, fromIsoWeekday(timetable.weekday));
   }

   return null;
}

function mapOptionalCommercialAgreementsForSave(optionalCommercialAgreements: Employment['optional_commercial_agreements'] | undefined) {
   return (optionalCommercialAgreements ?? [])
      .map((oca: any) => ({
         commercial_agreement_id: oca?.commercial_agreement_id ?? oca?.id,
      }))
      .filter((oca) => oca.commercial_agreement_id != null && oca.commercial_agreement_id !== '');
}

export function employmentMapper(employment: Employment) {
   return {
      ...employment,
      salary: fixedNumber(employment.salary, 4),
      salary_permanent_employee: employment.salary_permanent_employee ? fixedNumber(employment.salary_permanent_employee, 4) : null,
      social_subscription: fixedNumber(employment.social_subscription, 4),
      optional_commercial_agreements: mapOptionalCommercialAgreementsForSave(employment.optional_commercial_agreements),
      commuter_traffic: (employment.commuter_traffic ?? []).map((ct: any) => ({ ...ct, value: fixedNumber(ct.value, 4) })),
      fees: employment.fees
         ?.filter((fee: any) => Object.keys(fee).length > 0)
         .map((fee: any) => ({ ...fee, amount: fixedNumber(fee.amount, 2), value: fixedNumber(fee.value, 4) })),
      turnover_teams: employment.turnover_teams?.filter((turenoverTeam) => !!turenoverTeam.team_id),
      timetables: employment.timetables
         .map((timetable: Timetable) => {
            const date = resolveTimetableDate(timetable, employment.from);
            if (!date) return null;

            return {
               contract_id: employment.id,
               date,
               performances_comment: timetable.performances_comment,
               first_start_time: timetable.first_start_time ? `${date} ${timetable.first_start_time}` : null,
               first_stop_time: timetable.first_stop_time ? `${date} ${timetable.first_stop_time}` : null,
               second_start_time: timetable.second_start_time ? `${date} ${timetable.second_start_time}` : null,
               second_stop_time: timetable.second_stop_time ? `${date} ${timetable.second_stop_time}` : null,
               planned_hours: fixedNumber(timetable.planned_hours, 2),
               additional_hours: fixedNumber(timetable.additional_hours, 2),
            };
         })
         .filter((timetable): timetable is NonNullable<typeof timetable> => !!timetable)
         .filter((timetable) => dayjs(timetable.date).isBetween(dayjs(employment.from), dayjs(employment.till), 'day', '[]')),
   } as Employment;
}
